//@ts-nocheck
import { Editor, Transforms, Point, Element, Range, Path } from 'slate'
import { ReactEditor } from 'slate-react';

import { getText, isSelectionCollapsed } from '../../../utils/queries'

export const isLinkActive = (editor) => {
  const [link] = Editor.nodes(editor, { match: (n) => n.type === 'a' })
  return Boolean(link)
}

type LinkDetailObject = {
  url: string
  text: string
  inNewTab: boolean
  title?: string
}

type LinkAttribute = {
  type: string;
  attrs: { url: string; target: string; title?: string };
  children: { text: string }[];
}

export const getLinkDetail = (editor, selection) => {
  const [link] = Editor.nodes(editor, { match: (n) => n.type === 'a' })

  const linkDetailObject: LinkDetailObject = {
    url: '',
    text: '',
    inNewTab: false,
  }

  if (Boolean(link)) {
    const attrs: any = link[0].attrs

    linkDetailObject.url = attrs.url
    linkDetailObject.text = Editor.string(editor, link[1])
    linkDetailObject.inNewTab = attrs.target === '_blank'
    if(attrs.title) linkDetailObject.title = attrs.title
  } else if (!isSelectionCollapsed(selection)) {
    linkDetailObject.text = getText(editor, selection)
  }

  return linkDetailObject
}

export const unwrapLink = (editor) => {
  Transforms.unwrapNodes(editor, {
    match: (n) => n.type === 'a',
  })
  Transforms.setNodes(
    editor,
    {
      underline: false,
    },
    { match: (n: any) => n.underline }
  )
}

export const wrapLink = (editor?, url?, linkText?, newTab?, title ?: string) => {
  const isNewTab = newTab ?? false;
  const selection = editor.selection || editor.savedSelection
  if (!selection) {
    return
  }
  const text = linkText || url

  const linkAttribute: LinkAttribute = {
    type: 'a',
    attrs: { url, target: isNewTab ? '_blank' : '_self' },
    children: [{ text: text }],
  }
  if(title) linkAttribute.attrs.title = title

  if (isLinkActive(editor)) {
    // update existing data
    const [link] = Editor.nodes(editor, { match: (n) => n.type === 'a' })
    const linkObj: any = link[0]
    const linkPath = link[1]

    Transforms.select(editor, linkPath)
    Transforms.setNodes(
      editor,
      { attrs: { ...linkObj.attrs, ...linkAttribute.attrs } },
      {
        match: (n) => n.type === 'a',
      }
    )
    Transforms.insertText(editor, text, { at: editor.selection })
    Transforms.collapse(editor, { edge: 'end' })
  } else if (isSelectionCollapsed(selection)) {
    // create new node
    Transforms.insertNodes(editor, linkAttribute)
  } else {
    // wrap url
    Transforms.wrapNodes(editor, linkAttribute, { split: true })
    if(linkText && linkText !== Editor.string(editor, editor.selection)) {
      Transforms.insertText(editor, linkText, { at: editor.selection })
    }
    Transforms.collapse(editor, { edge: 'end' })
  }
}

export function handleCursorIfCursorEndOfLink (editor, isPointMatched) {
  const { selection } = editor
  if (!selection || !Range.isCollapsed(selection)) {
    return false
  }
  const [link] = Editor.nodes(editor, {
    match: (n) => Element.isElement(n) && n.type === 'a',
    mode: "lowest",
  })
  if (!link) {
    return false
  }
  const { anchor } = selection
  const [linkNode, linkPath] = link
  const endPoint = Editor.end(editor,linkPath)

  const isCursorMatched = isPointMatched(editor, anchor, endPoint)
  if (isCursorMatched)  {
    const nextPath = Path.next(linkPath)
    Transforms.select(editor, Editor.start(editor, nextPath));
  }
}

export function isVisuallyEqualPoint(
  editor: ReactEditor,
  pointA: Point,
  pointB: Point
): boolean {
  try {
    // Convert both Slate Points into DOM [node, offset] tuples
    const [domNodeA, domOffsetA] = ReactEditor.toDOMPoint(editor, pointA);
    const [domNodeB, domOffsetB] = ReactEditor.toDOMPoint(editor, pointB);
    // Same DOM node and same offset ⇒ same visual cursor position
    return domNodeA === domNodeB && domOffsetA === domOffsetB;
  } catch (e) {
    // If conversion fails (e.g. point out of document), treat as not equal
    console.error("Error comparing points:", e);
    return false;
  }
}